import {
  ContactShadows,
  Environment,
  OrbitControls,
  useCursor,
} from "@react-three/drei";

import { useAtom } from "jotai";
import { useState, useEffect, useRef, } from "react";
import { Map } from "./Map";

import Player from "./Player";

export const Experience = () => {

  return (
    <>
      <Map />
      <ContactShadows blur={2} />
      <OrbitControls />
      {/* <mesh
        rotation-x={-Math.PI / 2}
        position-y={-0.001}
        onClick={(e) => socket.emit("move", [e.point.x, 0, e.point.z])}
        onPointerEnter={() => setOnFloor(true)}
        onPointerLeave={() => setOnFloor(false)}
      >
        <planeGeometry args={[10, 10]} />
        <meshStandardMaterial color="#f0f0f0" />
      </mesh> */}

      {/* {characters.map((character) => (
        <Character
          key={character.id}
          ide={character.id}
          value={character.value}
          position={
            [
              0,
              0,
              0
            ]
          }
          angle={character.angle}
          hairColor={character.hairColor}
          topColor={character.topColor}
          bottomColor={character.bottomColor}
        />
      ))} */}
      <Player/>
    </>
  );
};
